export enum MapProvider {
    OpenStreetMap = "OpenStreetMap",
    GoogleMaps = "GoogleMaps",
}

export enum StaticMapProvider {
    GoogleMaps = "GoogleMaps",
    MapTiler = "MapTiler",
    MapBox = "MapBox",
    None = "None",
}